import 'style/apps.scss'
import ReactRailsUJS from 'react_ujs'

// Start react-rails
var componentRequireContext = require.context('apps/authentication/app', true)
ReactRailsUJS.useContext(componentRequireContext)
ReactRailsUJS.detectEvents()
